export enum PhotoDeleteReasons {
    User = 'User',
    Admin = 'Admin',
    Auto = 'Auto'
}

export const PhotoDeleteReasonsLabels: Record<PhotoDeleteReasons, string> = {
    [PhotoDeleteReasons.Auto]: 'Автоматически',
    [PhotoDeleteReasons.Admin]: 'Моредатор',
    [PhotoDeleteReasons.User]: 'Пользователь',
}